import { render, staticRenderFns } from "./CreateContract.vue?vue&type=template&id=7988d8d4&"
import script from "./CreateContract.vue?vue&type=script&lang=ts&"
export * from "./CreateContract.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports